import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { http } from "~/services/http";
import { fileDownload } from "~/helpers/file-download";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

async function downloadFile(url, fileGuid, fileName) {
  const file = await http.getFile(url, { fileGuid });
  fileDownload(file, fileName, file.type);
}

export const useDownloadStudyFile = (fileGuid) => {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  const fetcher = (url, { arg }) => {
    return downloadFile(url, fileGuid, arg);
  };

  const swrKey = isPreviewOrPrint
    ? null
    : `/api/studyfile/${fileGuid}/download`;

  const {
    trigger: download,
    isMutating: isDownloading,
    error,
  } = useSWRMutation(swrKey, fetcher);

  if (isPreviewOrPrint) {
    return {
      download: () => Promise.resolve(null),
      isDownloading: false,
      error: null,
    };
  }

  return { download, isDownloading, error };
};
